import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldSecond extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'second');
  }
}
